<template>
  <div class="page">
    <div class="page-header-wrapper">
      <div class="page-header">
        <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
        <p v-html="focus.cartouche ? focus.cartouche.texte : '' "></p>
      </div>
    </div>
    <div class="page-content-wrapper">
      <div class="page-content">
        <div>
          <h3 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h3>
          <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></p>
          <div class="img-wrapper">
            <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''">
          </div>
          <h3 v-html="focus.paragraphe2 ? focus.paragraphe2.titre : ''"></h3>
          <p v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ''"></p>
          <div class="img-wrapper">
            <img :src="focus.paragraphe2 ? focus.paragraphe2.image : ''">
          </div>
          <h3 v-html="focus.paragraphe3 ? focus.paragraphe3.titre : ''"></h3>
          <p v-html="focus.paragraphe3 ? focus.paragraphe3.texte : ''"></p>
          <div class="img-wrapper">
            <img :src="focus.paragraphe3 ? focus.paragraphe3.image : ''">
          </div>
          <h3 v-html="focus.paragraphe4 ? focus.paragraphe4.titre : ''"></h3>
          <p v-html="focus.paragraphe4 ? focus.paragraphe4.texte : ''"></p>
          <div class="img-wrapper">
            <img :src="focus.paragraphe4 ? focus.paragraphe4.image : ''">
          </div>
          <h3 v-html="focus.paragraphe5 ? focus.paragraphe5.titre : ''"></h3>
          <p v-html="focus.paragraphe5 ? focus.paragraphe5.texte : ''"></p>
          <div class="img-wrapper">
            <img :src="focus.paragraphe5 ? focus.paragraphe5.image : ''">
          </div>
          <h3 v-html="focus.paragraphe6 ? focus.paragraphe6.titre : ''"></h3>
          <p v-html="focus.paragraphe6 ? focus.paragraphe6.texte : ''"></p>
          <div class="img-wrapper">
            <img :src="focus.paragraphe6 ? focus.paragraphe6.image : ''">
          </div>
        </div>
      </div>
    </div>
    <div class="team-wrapper">
      <h2 v-html="focus.collaborateurs ? focus.collaborateurs.titre : ''"></h2>
      <div class="team-container">
        <div class="team-card" v-for="(collaborateur, idx) in collaborateurs" :key="idx">
          <div class="team-card-head">
            <h4>{{ collaborateur.prenom }}</h4>
            <p>{{ collaborateur.poste }}</p>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
            <polygon points="0,0 100,0 0,100" />
          </svg>
          <div class="team-card-content">
            <p v-html="collaborateur.d_presentation"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="team-form-wrapper" v-if="focus.recrutement">
      <div class="team-form-container">
        <p v-html="focus.recrutement ? focus.recrutement.texte : ''"></p>
        <router-link :to="{ name: siteCode.toUpperCase() + 'RecrutementForm' }">
          <button class="cg-btn cg-btn-primary" v-html="focus.recrutement ? focus.recrutement.titre : ''"></button>
        </router-link>  
      </div>
    </div>
    <site-link :siteName="siteName"></site-link>
  </div>
</template>

<script>
import DataApi from 'fm-data-api'
import { getFocus } from '../../mixins/getFocus'
import SiteLink from '../Components/SiteLink.vue'

export default {
  name: 'ImmoAgence',
  mixins: [getFocus],
  components: {
    SiteLink
  },
  props: {
    siteCode: String
  },
  data() {
    return {
      collaborateurs: {},
      focus: {},
      siteName: this.siteCode == 'cg' ? 'Courtage' : this.siteCode == 'ti' ? 'Immobilier' : 'Patrimoine'
    }
  },
  methods: {
    async loadCollaborateurs() {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.findRecords('W_Collaborateur', { 'col_SOC__Societe::d_nomSociete': 'Giordano ' + this.siteName }, '', '', '')
        .then((response) => {
          this.insertCollaborateurs(response)
        })
    },
    insertCollaborateurs(collaborateursList) {
      if (collaborateursList.length > 0) {
        const collaborateursToInsert = {}
        collaborateursList.forEach(function (value, index) {
          const dataToInsert = value.fieldData
          dataToInsert.recordId = value.recordId
          collaborateursToInsert[dataToInsert.ordre] = dataToInsert
        })
        this.collaborateurs = collaborateursToInsert
      } else {
        this.collaborateurs = {}
      }
    }
  },
  created() {
    this.loadCollaborateurs()
  },
  async beforeMount() {
    let pageName = this.siteCode == 'cg' ? 'Équipe' : this.siteCode == 'ti' ? 'Agence' : 'Notre équipe'
    await this.getFocus(this.siteCode, pageName)
      .then(res => {
        this.focus = res
      })
  }
}
</script>

<style lang="scss" scoped>
.page {
  background-color: var(--color-background-light-grey);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .page-header-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .page-header {
    display: flex;
    align-items: flex-start;
    max-width: var(--max-width);
    width: 100%;
  }

  .page-content-wrapper {
    background-color: white;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .page-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px 16px;

      p {
        text-align: justify;
      }
      
      &>* {
        max-width: var(--max-width);
      }

      .img-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;

        img {
          max-width: 700px;
          width: 100%;
          height: auto;
        }
      }
    }
  }
}

.team-wrapper {
  max-width: var(--max-width);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 16px;

  .team-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 32px 0;
  }

  .team-card {
    width: 320px;
    height: 350px;
    border-radius: 10px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.2);
    background-color: #fff;
    position: relative;
    margin: 24px 16px;
    text-align: left;

    .team-card-head {
      background-color: var(--color-primary);
      color: white;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      padding: 0px 40px;
      border-radius: 10px 10px 0 0;
      height: 50%;
    }

    svg {
      position: absolute;
      right: 0;
      width: 100%;
      height: 40px;
      fill: var(--color-primary)
        /* set height to pixels if you want angle to change with screen width */
    }

    .team-card-content {
      padding: 40px 40px 16px 40px;
    }

    p {
      margin: 0;
    }
  }
}

.team-form-wrapper {
  width: 100%;
  background-color: var(--color-background-dark);
  display: flex;
  justify-content: center;
}

.team-form-container {
  max-width: var(--max-width);
  width: 100%;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 64px 16px;
  flex-direction: column;

  &>p {
    margin: 24px 0;
  }
}
</style>
